import { Link } from "wouter";
import type { ServiceItem } from "@/types/services";

interface RelatedServicesProps {
  currentService: string;
  services: ServiceItem[];
}

const SERVICE_URLS: Record<string, string> = {
  "Web Design & Development": "/web-design-development",
  "Web Design Dubai": "/web-design-dubai",
  "Web Design UAE": "/web-design-uae",
  "Web Design Sharjah": "/web-design-sharjah",
  "Web Design Ajman": "/web-design-ajman",
  "Web Design Fujairah": "/web-design-fujairah",
  "Web Design Ras Al Khaimah": "/web-design-ras-al-khaimah",
  "Web Design Umm Al Quwain": "/web-design-umm-al-quwain",
  "Web Design Al Ain": "/web-design-al-ain",
  "Web Design USA": "/web-design-usa",
  "Mobile App Development": "/mobile-app-development",
  "Cloud Services": "/cloud-services",
  "UI/UX Design": "/ui-ux",
  "SEO": "/seo",
  "Digital Marketing": "/digital-marketing",
  "Cyber Security": "/cyber-security",
  "Data Analytics": "/data-analytics",
  "E-Commerce": "/ecommerce",
  "Branding": "/branding",
  "Consulting": "/consulting",
  "Custom Apps": "/custom-apps",
  "Domain Registration": "/domain-registration",
  "Email Hosting": "/email-hosting",
  "ERP/CRM": "/erp-crm",
  "Maintenance & Support": "/maintenance-support",
  "Software Development": "/software-development",
  "Web Hosting": "/web-hosting"
};

export function RelatedServices({ currentService, services }: RelatedServicesProps) {
  const relatedServices = services.filter(service => 
    service.title !== currentService
  ).slice(0, 3);

  return (
    <div className="mt-12">
      <h3 className="text-2xl font-bold mb-6">Related Services</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {relatedServices.map((service) => (
          <Link 
            key={service.title}
            href={SERVICE_URLS[service.title]}
            className="p-6 border rounded-lg hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center gap-3 mb-3">
              {service.icon}
              <h4 className="text-lg font-medium">{service.title}</h4>
            </div>
            <p className="text-gray-600">{service.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
